




import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class ButtonInspectResult extends Vue {
  created() {}
  goStatusResult() {
    this.$router.push({ name: "statusresult" });
  }
}
